import { useState } from "react";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './register.css'
import splashlogo from '../splash/images/logo.png';

const Register = () => {
    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [phone, setPhone] = useState('');
    const [dob, setDob] = useState('');
    const [gender, setGender] = useState('M');
    const navigate = useNavigate();

    const handleSubmit = async (evt) => {
        evt.preventDefault();
    
        // Validation
        let errorMessage = "";
        if (!firstname) errorMessage = 'First Name cannot be empty';
        else if (!lastname) errorMessage = 'Last Name cannot be empty';
        else if (!username) errorMessage = 'Username cannot be empty';
        else if (!phone) errorMessage = 'Phone number cannot be empty';
        else if (!dob) errorMessage = 'Please select your Date of Birth';
        else if (!gender) errorMessage = 'Please select your gender';
        else if (password.length < 3) errorMessage = 'Password must be at least 3 characters';
    
        if (errorMessage) {
            alert(errorMessage);
            return; // Exit early if validation fails
        }
    
        console.log("Validation passed, proceeding with API call...");
    
        // API Call
        try {
            const response = await axios.post(`${process.env.VITE_APP_API_URL}/api/Account/Registration`, {
                "firstname": firstname,
                "lastname": lastname,
                "emailId": username,
                "password": password,
                "phoneNumber": phone,
                "dateOfBirth": dob,
                "gender": gender,
                "roleId": 1
            });


            console.log("REGISTER -- HANDLE SUBMIT");
            console.log("============================================");
            console.log("firstname: ", firstname);
            console.log("emailId: ", username);
            console.log("password: ", password);
            console.log("phoneNumber: ", phone);
            console.log("dateOfBirth: ", dob);
            console.log("gender: ", gender);
            console.log("roleId: ", 1);
            console.log('Response: ', response)
    
            // Navigate on successful registration
            if (response.data.status) {
                console.log("Registration successful, navigating...");
                navigate('/splash', { replace: true });
            } else {
                alert("Please fill in valid details");
            }
        } catch (error) {
            console.error("Error in registration:", error);
            alert("Registration failed, please try again later.");
        }
    };



    return (
        <>
            <div className='login-form bg-set register-form'>
                <form onSubmit={handleSubmit}>
                    <img src={splashlogo} alt='splashlogo' className='login-logo' />
                    <div className='username'>
                        <label>First Name</label>
                        <input type='text' value={firstname} onChange={(e) => { setFirstname(e.target.value) }} />
                    </div>
                    <div className='username'>
                        <label>Last Name</label>
                        <input type='text' value={lastname} onChange={(e) => { setLastname(e.target.value) }} />
                    </div>
                    <div className='username'>
                        <label>Username</label>
                        <input type='text' value={username} onChange={(e) => { setUsername(e.target.value) }} />
                    </div>
                    <div className='username'>
                        <label>Phone No</label>
                        <input type='number' value={phone} onChange={(e) => { setPhone(e.target.value) }} />
                    </div>
                    <div className='username'>
                        <label>Date Of Birth</label>
                        <input type='date' value={dob} onChange={(e) => { setDob(e.target.value) }} />
                    </div>
                    <div className='username genderhide'>
                        <label>Gender</label>
                        <select className="form-select" value={null} onChange={(e) => { setGender(e.target.value) }}>
                            <option value="Select" disabled selected>Select</option>
                            <option value="M">M</option>
                            <option value="F">F</option>
                        </select>
                        {/* <input type='text' value={gender} onChange={(e) => { setGender(e.target.value) }} disabled /> */}
                    </div>
                    <div className='username password'>
                        <label>Password</label>
                        <input type='password' value={password} onChange={(e) => { setPassword(e.target.value) }} autoComplete="off" />
                    </div>

                    <div className='btn-wrap'>
                        <button type='submit'>Sign up</button>
                    </div>
                </form>
            </div>
        </>
    )
}

export default Register
